import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-receipt-comment-next',
  templateUrl: './receipt-comment-next.component.html',
  styles: [],
})
export class ReceiptCommentNextComponent
  extends ExcTranslation
  implements OnInit
{
  @Input() data: any;

  dataModel: any;
  dataModelClone: any;
  hintText = 'für den nächsten Bearbeiter';

  constructor(
    public popUpService: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.popUpService.close();
  }

  save(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      this.popUpService.action(this.dataModelClone);
    }
  }
}
